module.exports = __webpack_public_path__ + "/images/cover-box-sorteo-md.42d520b.jpg";